import CustomKendoWindow from "./CustomKendoWindow";
import widgetTemplate from '../../templates/widgetTemplate.html';
import Constants from "../main/Constants";
import VideoWindow from "./VideoWindow";
export default class TesterKendoWindow extends CustomKendoWindow {
    constructor(context, testerIdentifier) {
		super(context, testerIdentifier);
        this.init();
	}

	init(){
		this.createKendoWindow();
		this.beingCalled = false;
		this.addKeyboardShortcuts();
	}

	getKeyboardCommands() {
		return [
			//when adding new commands, make sure all of the keys are in lower case
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "k"], run : this.context.handBtnClickHandler.bind(this.context)},
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "c"], run : this.toggleChat.bind(this)},
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "u"], run : this.toggleVideo.bind(this)},
			{keys : [Constants.Keys.CONTROL, "m"], run : this.muteAudio.bind(this)},
			{keys : [Constants.Keys.ALT, Constants.Keys.SHIFT, "a"], run : this.answerCall.bind(this)},
			{keys : [Constants.Keys.ALT, Constants.Keys.SHIFT, "c"], run : this.switchToChatWithTextFocus.bind(this)}
		];
	}

	createKendoWindow(){
		var that = this;
		this.kendoWindow = this.windowDiv.kendoWindow({
			width: "265px",
			height: "400px",
			minWidth: "265px",
			minHeight:"400px",
			actions: ["Hand","Chat", "Minimize"],
			autoFocus: true,
			visible : false,
			minimize: function(event) {
				that.handleKendoWindowMinimize(event);
			},
			restore: function (event) {
				that.kendoWindowRestore(event);
			},
			dragend: function (e) {
				CustomKendoWindow.clamp(that.kendoWindow);
			}
		}).data('kendoWindow');

		this.kendoChat.wrapper.find('.k-message-box').hide();
		RTP.UIUtil.hideElement(this.toolsTab);
		this.changeEndBtnToAnswerBtn();
		//hide endcall/endchat button
		RTP.UIUtil.hideElement(this.endBtn)
		this.unseenChatBtn = this.kendoWindow.wrapper.find('button[aria-label="Chat"]');
		this.unseenChatBtn.hide();

		this.kendoWindow.wrapper.find('button[aria-label="Hand"]').removeClass('k-button-flat');
		this.kendoWindow.wrapper.find('button[aria-label="Hand"]').find('span').addClass('fa-solid fa-hand');

		this.kendoWindow.wrapper.find('button[aria-label="Chat"]').find('span').addClass('fa-comment fa-solid');
		var titleTemplate = _.template($(widgetTemplate).filter("#recordSymbolDisplay").html());
		$('#window-'+this.testerIdentifier+'_wnd_title')[0].innerHTML = titleTemplate();

		//Create one video window per kendo window
		this.videoWindow = new VideoWindow(this.context, this.testerIdentifier);
		this.videoDiv = $("#videoWindow-"+this.testerIdentifier)

		this.center();
		this.addTooltips();
		this.errorHandler();
		this.preventDblClickAndRightClick();

		this.kendoWindow.open();
	}

	addTooltips(){
		$k('#recordSymbol').kendoTooltip({position: "bottom" , content: rtp_i18next.t("generalWords:recRedDot")});
		super.addTooltips.call(this, false);
	}

	answerCall() {
        if (this.isBeingCalled()) {
            this.answerBtnClickHandler();
        }
    }

    muteAudio() {
        if(this.isVideoCallRunning()) {
            this.videoWindow.muteAudioBtnClickHandler();
        }
    }

    switchToChatWithTextFocus() {
        if (this.isBeingCalled || this.isVideoCallRunning) {
            this.switchToChat();
        }
        this.kendoChat.wrapper.find('.k-input-inner').focus();
    }


	changeEndBtnToAnswerBtn(){
		this.endBtn[0].innerHTML = rtp_i18next.t('testerWidget:answerCall');
		this.endBtn.addClass('rtp-answerCallBtn');
		this.endBtn.removeClass('endBtn');
	}

	handleKendoWindowMinimize(event){
		this.minimizeKendoWindow();
		this.kendoWindow.wrapper.find('button[aria-label="window-restore"]').kendoTooltip({position: "right" , content: rtp_i18next.t("generalWords:maximize")});
	}

	minimizeKendoWindow(){
		this.kendoWindow.wrapper.css({ top: window.innerHeight - this.kendoWindow.wrapper[0].clientHeight - 5,
			left:10});
	}
	handleWindowResize(event){
		if(this.kendoWindow.element.is(":hidden")){
			this.minimizeKendoWindow()
		}else{
			this.center();
		}
	}

	kendoWindowRestore(event){
		if(this.unseenChatBtn[0].style.display.toLowerCase() !== 'none'){
			this.unseenChatBtnClickHandler();
		}
		this.center();
		if (this.allowMinimize) {
			CustomKendoWindow.restoreMinimizeButton(this.kendoWindow);
		} else {
			CustomKendoWindow.hideMinimizeButton(this.kendoWindow);
		}
	}

	center() {
        this.kendoWindow.options.position.top = ($(window).height() / 2) - (this.kendoWindow.wrapper.height() / 2);
        this.kendoWindow.options.position.left = ($(document).width() / 2) - (this.kendoWindow.wrapper.width() / 2);
        this.kendoWindow.wrapper.css('left', this.kendoWindow.options.position.left);
        this.kendoWindow.wrapper.css('top', this.kendoWindow.options.position.top);
    }

	errorHandler(){
		//Kendo seems to have a bug with custom icons, which causes console errors.  This catches the error so that no console errors will be shown.
		let _actionForIcon = this.kendoWindow._actionForIcon;
		this.kendoWindow._actionForIcon = function(e) {
			try {
				return _actionForIcon(e);
			} catch(e) {
				console.log(e);
			}
		};
	}

	attachListeners(){
		this.videoBtn.off('click',this.videoBtnClickHandler.bind(this)).on('click',this.videoBtnClickHandler.bind(this));
		this.chatBtn.off('click',this.chatBtnClickHandler.bind(this)).on('click',this.chatBtnClickHandler.bind(this));
		this.endBtn.off('click',this.answerBtnClickHandler.bind(this)).on('click',this.answerBtnClickHandler.bind(this));
		$(window).off('resize',this.handleWindowResize.bind(this)).on('resize',this.handleWindowResize.bind(this));
	}

	chatBtnClickHandler(){
		super.chatBtnClickHandler.call(this);
	}

	videoBtnClickHandler(e){
		super.videoBtnClickHandler.call(this);
	}

	endCallHandler(testerIdentifier){
		RTP.UIUtil.hideElement(this.toolsTab);
		this.showAnswerCallBtn();
		this.changeVideoLabelToVideo(testerIdentifier);
		this.chatBtnClickHandler();
		CustomKendoWindow.restoreMinimizeButton(this.kendoWindow);
	}

	changeVideoLabelToVideo(testerIdentifier){
		CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier), rtp_i18next.t("generalWords:video"),false);
	}

	handleCallRecieved(){
		this.setIsBeingCalled(true);
		RTP.UIUtil.showElement(this.toolsTab);
		this.videoBtnClickHandler();
		this.changeEndBtnToAnswerBtn();
		this.showAnswerCallBtn();
	}

	answerBtnClickHandler(e) {
		if($(e.currentTarget)[0].classList.contains('joinGroupCall')){
			this.handleJoinGroupCallClick();
			return;
		}
		if (!this.isVideoCallRunning()) {
			// Start the video call
			this.handleAnswerCallClick()
		}
	}

	handleAnswerCallClick(){
		this.context.stopCallChime();
		this.hideAnswerCallBtn();
		this.videoStatusMsg(this.testerIdentifier, rtp_i18next.t("generalWords:callConnecting"));
		CustomKendoWindow.hideMinimizeButton(this.kendoWindow);
		this.context.enableVideoToolBarBtns(this.testerIdentifier);
		this.context.cancelAnswerCallTimeout();
		this.setIsBeingCalled(false);
		this.context.startVideoCall(this.testerIdentifier).then(
			(startCallSuccess) => {
				if (startCallSuccess) {
					this.context.enableVideoToolBarBtns(this.testerIdentifier);
					CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier), rtp_i18next.t("videoMonitoring:inVideoCall"), true);
					this.videoWindow.setAudioIconStatus(false, true);
					this.videoStatusMsg(this.testerIdentifier, rtp_i18next.t("generalWords:callConnected"));
				} else {
					this.endCallHandler(this.testerIdentifier);
				}
			}
		);
	}

	postMessage(message) {
		let textMessage = {'text' : message.data.text, 'timestamp' : message.data.jsonTimestamp, 'msgId': message.data.msgId, 'historical': message.data.isHistorical};
		if (typeof message.data.text === 'object') {
			textMessage = message.data.text;
		}
		if (message.data.isHistorical && message.data.senderType === Constants.Role.TESTER) {
			this.postHistoryChat(textMessage);
		}
		if (message.data.senderType !== Constants.Role.TESTER) {
			this.postChatMsg(message);
		}
	}

	postHistoryChat(textMessage){
		this.kendoChat.postMessage(textMessage);
		return;
	}

	postChatMsg(message){
		if (!message.data.msgId) {
			let sampleId=crypto.randomUUID();
			message.data.msgId = 'rtpmsg_'+sampleId;
		}
		this.kendoChat.renderMessage({
			type: "text",
			text: message.data.text,
			msgId: message.data.msgId,
			timestamp : new Date(message.data.jsonTimestamp)
		}, {
			name: rtp_i18next.t("proctorWidget:proctor")
		});

		this.showUnseenChatCountIfMinimized();
		this.highlightIfChatNotInFocus();
	}

	showUnseenChatCountIfMinimized(){
		if(this.kendoWindow.isMinimized()){
			this.unseenChatCount+=1;
			if(this.unseenChatBtn[0].style.display.toLowerCase() === 'none'){
				if($('button[aria-label="Chat"]>.unseenChatCount').length == 0){
					this.addUnseenChatCountSpan();
				}
				this.showUnseenChatIcon();
			}
			$('.unseenChatCount')[0].innerText = this.unseenChatCount;
		}
	}

	showUnseenChatIcon(){
		this.unseenChatBtn.show();
		this.unseenChatBtn.one('click',this.unseenChatBtnClickHandler.bind(this));
		this.unseenChatBtn.kendoTooltip({position: "top" , content: rtp_i18next.t("generalWords:newMessages")});
	}

	addUnseenChatCountSpan(){
		let unseenChatCountSpan = $('<span />').addClass('unseenChatCount chat-notification');
		this.unseenChatBtn[0].append(unseenChatCountSpan[0]);
	}

	unseenChatBtnClickHandler(){
		this.unseenChatBtn.hide();
		// this.kendoWindow.wrapper.find('button[aria-label="window-restore"]').show(); //cleanup lates based on final decission
		this.unseenChatCount = 0;
		this.kendoWindow.restore();
		this.context.sendUnseenReceivedChatMessage(this.testerIdentifier);
	}

	highlightIfChatNotInFocus(){
		this.kendoWindow.wrapper.is(':focus')? '': this.kendoWindow.wrapper.addClass('highlightChatWindow');
		this.kendoWindow.wrapper.on('focusin',this.removeHighlightIfChatInFocus.bind(this));
	}

	removeHighlightIfChatInFocus(){
		this.kendoWindow.wrapper.off('focusin',this.removeHighlightIfChatInFocus.bind(this));
		this.kendoWindow.wrapper.removeClass('highlightChatWindow');
	}

	//video call pane

	videoStatusMsg(testerIdentifier, statusMsg) {
		document.querySelector('#displayVideoStatusText_' + testerIdentifier).innerHTML = statusMsg;
	}

	//broadcast call
	handleBroadcastCall(){
		this.videoBtn.addClass("groupCall")
		RTP.UIUtil.showElement(this.toolsTab);
		$("#testerGroupAudioCallWindow").length == 0 && this.createBroadCastWindow();
		super.videoBtnClickHandler();
		this.switchToGroupCallView();
		this.changeEndBtnToJoinGroupCall(); //once joined change to answer call btn
		this.showAnswerCallBtn(); //once joined hide this
		this.changeVideoBtnIconToGroupCallIcon();
	}

	createBroadCastWindow(){
		let groupCallWindowHTML =  _.template($(widgetTemplate).filter("#groupAudioCallTesterView").html());
		this.callVideoContainer.append(groupCallWindowHTML());
	}

	handleJoinGroupCallClick(){
		this.setAudioCallRunning(true);
		this.context.joinGroupAudioCallClicked();
		this.showJoinedAudioCallView();
		this.changeJoinGroupCallBtnToEndBtn();
		CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier),rtp_i18next.t('generalWords:inGroupCall'), true);
		CustomKendoWindow.hideMinimizeButton(this.kendoWindow);
		this.hideAnswerCallBtn();
		this.addJoinedGroupCallMuteTooltip(true);
	}

	handleEndBroadcastCall(){
		this.setAudioCallRunning(false);
		RTP.UIUtil.hideElement(this.toolsTab);
		this.changeGroupCallBtnIconToVideoIcon();
		this.changeJoinGroupCallBtnToEndBtn();
		this.switchToVideoCallView();
		super.handleSwitchToChatView();
		CustomKendoWindow.restoreMinimizeButton(this.kendoWindow);
		this.restoreJoinGroupCallWindow();
		this.videoBtn.removeClass("groupCall");
	}

	restoreJoinGroupCallWindow(){
		this.toggleProctorGroupMuteIcon();
		this.toggleLocalGroupMuteIcon(true);
	}

	switchToGroupCallView(){
		RTP.UIUtil.hideElement(this.videoDiv);
		RTP.UIUtil.showElement($("#testerGroupAudioCallWindow"));
		let videoLabel = this.isAudioCallRunning() ? rtp_i18next.t('generalWords:inGroupCall'):rtp_i18next.t('generalWords:groupCall')
		CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier),videoLabel, false);
	}

	switchToVideoCallView(){
		this.hideJoinedAudioCallView();
		RTP.UIUtil.hideElement($("#testerGroupAudioCallWindow"));
		RTP.UIUtil.showElement(this.videoDiv);
		this.changeVideoLabelToVideo(this.testerIdentifier);
	}

	showJoinedAudioCallView(){
		RTP.UIUtil.hideElement($("#rtp_recieveAudioCallWindow"));
		RTP.UIUtil.showElement($("#rtp_joinedAudioCallWindow"));
	}

	hideJoinedAudioCallView(){
		RTP.UIUtil.hideElement($("#rtp_joinedAudioCallWindow"));
		RTP.UIUtil.showElement($("#rtp_recieveAudioCallWindow"));
	}

	switchToVideoCallTooltips(){
		this.videoBtn.data("kendoTooltip").destroy();
		this.videoBtn.kendoTooltip({position: "right" , content: rtp_i18next.t('videoMonitoring:videoCall')});
	}

	addJoinedGroupCallMuteTooltip(){
        $k('#rtp_groupCallMuteAudioIcon').kendoTooltip({position: "left" ,content: rtp_i18next.t("testerWidget:testerMicMuted")});
	}

	changeEndBtnToJoinGroupCall(){
		this.endBtn.addClass('joinGroupCall');
		this.changeEndBtnToAnswerBtn();
		this.endBtn[0].innerHTML = rtp_i18next.t('testerWidget:joinGroupCall');
	}

	changeJoinGroupCallBtnToEndBtn(){
		this.changeEndBtnToAnswerBtn();
		this.endBtn.removeClass('joinGroupCall');
	}

	changeVideoBtnIconToGroupCallIcon(){
		$('#videoIcon-'+this.testerIdentifier)[0].classList.remove('fa-video');
		$('#videoIcon-'+this.testerIdentifier)[0].classList.add('fa-phone');
	}

	changeGroupCallBtnIconToVideoIcon(){
		$('#videoIcon-'+this.testerIdentifier)[0].classList.remove('fa-phone');
		$('#videoIcon-'+this.testerIdentifier)[0].classList.add('fa-video');
	}

    toggleVideo() {
        if (this.isBeingCalled() || this.isVideoCallRunning()) {
            this.videoBtnClickHandler();
        }
    }

    toggleChat() {
        if (this.isBeingCalled() || this.isVideoCallRunning()) {
            this.switchToChat();
        }
    }

	showAnswerCallBtn() {
		RTP.UIUtil.showElement(this.endBtn)
	}

	hideAnswerCallBtn(){
		RTP.UIUtil.hideElement(this.endBtn);
	}

	isBeingCalled() {
		return this.beingCalled;
	}

	setAudioCallRunning(flag){
		this.audioCallRunning = flag;
	}

	toggleLocalGroupMuteIcon(isMuted) {
		let icon = $('#rtp_groupCallMuteAudioIcon');
		let audioCallMsg = $('#rtp_groupAudioCall_msg');
		if(isMuted) {
			icon.show();
			audioCallMsg?.html(rtp_i18next.t("generalWords:groupAudioCallMutedTesterMsg"));
		} else {
			icon.hide();
			audioCallMsg?.html(rtp_i18next.t("generalWords:groupAudioCallUnmutedTesterMsg"));
		}
	}

	toggleProctorGroupMuteIcon(isMuted) {
		let icon = $('#rtp_groupCallspeakerIcon');
		let statusText = $('#rtp_groupAudioCall_status');
		if(isMuted) {
			icon.removeClass('rtp_active_bg');
			icon.removeClass('fa-volume-high');
			icon.addClass('rtp_inactive_bg');
			icon.addClass('fa-volume-xmark');
			statusText.html(rtp_i18next.t("testerWidget:proctorMuted"));
			statusText.addClass('rtp_inactive_bg');
			statusText.removeClass('rtp_active_bg');
		} else {
			icon.removeClass('rtp_inactive_bg');
			icon.removeClass('fa-volume-xmark');
			icon.addClass('rtp_active_bg');
			icon.addClass('fa-volume-high');
			statusText.html(rtp_i18next.t("generalWords:callConnected"));
			statusText.addClass('rtp_active_bg');
			statusText.removeClass('rtp_inactive_bg');
		}
	}

	cleanupController(){
		this.kendoWindow.destroy();
		this.setAudioCallRunning(false);
	}
}
